import React from "react";
import { cn } from "@/lib/utils/cn";

interface ProgressProps extends React.HTMLAttributes<HTMLDivElement> {
  value?: number;
  max?: number;
  showLabel?: boolean;
}

export function Progress({ className, value = 0, max = 100, showLabel, ...props }: ProgressProps) {
  const percentage = Math.min(Math.max((value / max) * 100, 0), 100);

  return (
    <div
      className={cn(
        "relative h-2 w-full overflow-hidden rounded-full bg-muted/10",
        className
      )}
      role="progressbar"
      aria-valuenow={value}
      aria-valuemin={0}
      aria-valuemax={max}
      {...props}
    >
      <div
        className="h-full flex-1 bg-primary transition-all duration-500 ease-out"
        style={{ width: `${percentage}%` }}
      />
      {showLabel && (
        <span className="sr-only">{Math.round(percentage)}%</span>
      )}
    </div>
  );
}
Progress.displayName = "Progress";
